const { SUCCESS_MESSAGES } = require("../constants/successMessages");

const POINT_VALUES = [25, 50, 100, 200];

function getRandomPoints() {
  return POINT_VALUES[Math.floor(Math.random() * POINT_VALUES.length)];
}

function getSuccessMessage(points) {
  const pointMessages = SUCCESS_MESSAGES[points];
  if (!pointMessages) return "";
  return pointMessages[Math.floor(Math.random() * pointMessages.length)];
}

module.exports = { getRandomPoints, getSuccessMessage, POINT_VALUES };
